export function filterByStringIgnoreCase<T extends Object>(
  items: Array<T>,
  filtro: string | undefined
): Array<T> {
  if (!filtro || filtro === "") {
    return items;
  }

  return items.filter(
    (items) =>
      Object.values(items).filter(
        (val) =>
          val !== undefined &&
          val !== null &&
          val.toString().toLowerCase().includes(filtro.toLowerCase())
      ).length > 0
  );
}


export function generatePage(
  rows: Array<any>,
  pageNumber: number,
  pageSize: number
): Array<any> {
  const end = pageNumber * pageSize;
  const start = end - pageSize;
  return rows.slice(start, end);
}